import router from '@/router';

const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:2200';

const appmixer = new window.Appmixer({
    baseUrl,
    tokenEncryptionKey: process.env.VUE_APP_ENCRYPTION_SECRET || 'secret',
    accessToken: sessionStorage.getItem('accessToken') || null,
    refreshToken: sessionStorage.getItem('refreshToken') || null
});

appmixer.api.on('tokenRefreshFailed', () => {
    appmixer.api.delete('accessToken');
    appmixer.api.delete('refreshToken');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    router.replace({ name: 'Login', query: { to: window.location.href } });
});

appmixer.api.on('accessTokenRefreshed', (tokens) => {
    if (tokens.accessToken && tokens.refreshToken) {
        sessionStorage.setItem('refreshToken', tokens.refreshToken);
        sessionStorage.setItem('accessToken', tokens.accessToken);
    }
});

export default appmixer;
